<div class="flex justify-content-between align-items-center py-3 px-4 border-round-lg mb-2" style="background-color: rgba(10, 131, 0, 0.08);">
    <div class="flex flex-column">
        <span class="balance-title">Disponível para saque</span>
        <span class="balance-value">
            {{ availableForWithdrawal | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
        </span>
    </div>
    <div class="flex flex-column align-items-end">
        <span class="pending-title" pTooltip="Valor em processamento (D+2) úteis. Ainda não disponível para saque.">
        A liquidar</span>
        <span class="pending-value">
            {{ toBeLiquidated | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
        </span>
        <span class="pending-info">
            D+2 · não disponível agora
        </span>
    </div>
</div>